<template>
  <el-container :class="{ 'auth-mobile-layout': isSimpleAuthLayout }">
    <el-header v-if="!isSimpleAuthLayout && useCompactNav && !isAdminRoute">
      <MobileNavBar
        :is-logged-in="isLoggedIn"
        :user-info="userInfo"
        :is-system-admin="isSystemAdminUser"
        @logout="logout"
      />
    </el-header>
    <el-header v-else-if="!isSimpleAuthLayout">
      <div class="header-container">
        <el-menu mode="horizontal" :router="true" class="nav-menu">
          
          <el-menu-item index="/">
            <!-- <el-icon><House /></el-icon> -->
            <img src="@/assets/coolpeople.png" alt="logo" class="logo">
          </el-menu-item>

          <!-- moment -->


          <el-menu-item index="/blogs">
            <el-icon><Document /></el-icon>
            编辑推荐
          </el-menu-item>
          
          <el-menu-item index="/exames">
            <el-icon><InfoFilled /></el-icon>
            心智测试
          </el-menu-item>


          <el-menu-item index="/knowledge/courses">
            <el-icon><InfoFilled /></el-icon>
            知识课程
          </el-menu-item>

          <el-menu-item index="/referral/bind-coupon">
            <el-icon><Ticket /></el-icon>
            绑定礼券
          </el-menu-item>
          
          <el-menu-item index="/download-app">
            <el-icon><Download /></el-icon>
            下载APP
          </el-menu-item>
      

      
          
      

          <!-- <el-menu-item index="/ai-chat">
            <el-icon><InfoFilled /></el-icon>
            AI聊天
          </el-menu-item> -->
          
          
          <el-sub-menu index="social">
            <template #title>
              <el-icon><InfoFilled /></el-icon>
              <span>朋友</span>
            </template>


            <el-menu-item index="/moment">
            <el-icon><Document /></el-icon>
            时刻
          </el-menu-item>

            <el-menu-item index="/search">
            <el-icon><Search /></el-icon>
            遇见
            </el-menu-item>

           
            <!-- <el-menu-item index="/moment">
            <el-icon><InfoFilled /></el-icon>
            时刻
          </el-menu-item> -->

            <el-menu-item index="/people">
              <el-icon><InfoFilled /></el-icon>
              推荐
            </el-menu-item>
            <el-menu-item index="/like">
              <el-icon><InfoFilled /></el-icon>
              朋友
            </el-menu-item>
            <el-menu-item index="/visite">
              <el-icon><View /></el-icon>
              <span>访问</span>
            </el-menu-item>
          </el-sub-menu>


          <el-menu-item index="/help">
            <el-icon><QuestionFilled /></el-icon>
            帮助
          </el-menu-item>

          <el-menu-item index="/faq">
            <el-icon><ChatDotRound /></el-icon>
            常见问题
          </el-menu-item>
          
    

          <el-menu-item index="/my">
            <el-icon><InfoFilled /></el-icon>
            我的
          </el-menu-item>

         

         
        </el-menu>
        
        <template v-if="isLoggedIn">
          <div class="user-menu-item">
            <el-dropdown trigger="click">
              <div class="user-dropdown-trigger">
                <el-avatar :size="32" :src="userInfo.avatar">
                  {{ userInfo.nickname?.[0] || userInfo.username?.[0] }}
                </el-avatar>
                <span class="username-text">{{ userInfo.nickname || userInfo.username }}</span>
                <el-icon class="el-icon--right"><CaretBottom /></el-icon>
              </div>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item @click="$router.push('/user/info')">
                    <el-icon><User /></el-icon>
                    <span>个人信息</span>
                  </el-dropdown-item>

                  <el-dropdown-item @click="$router.push('/user/password')">
                    <el-icon><Setting /></el-icon>
                    <span>账户密码</span>
                  </el-dropdown-item>

                  <el-dropdown-item @click="$router.push('/knowledge/progress')">
                    <el-icon><InfoFilled /></el-icon>
                    <span>学习进度</span>
                  </el-dropdown-item>

                  <!-- <el-dropdown-item @click="$router.push('/knowledge/courses')">
                    <el-icon><Document /></el-icon>
                    <span>知识课程</span>
                  </el-dropdown-item> -->

                  <el-dropdown-item>
                    <el-divider />
                  </el-dropdown-item>

                  <el-dropdown-item v-if="isSystemAdminUser" @click="$router.push('/admin')">
                    <el-icon><Setting /></el-icon>
                    <span>管理员后台</span>
                  </el-dropdown-item>

                  <el-dropdown-item v-if="isSystemAdminUser" @click="$router.push('/knowledge/graph/editor')">
                    <el-icon><Share /></el-icon>
                    <span>关系图编辑器</span>
                  </el-dropdown-item>

                  <el-dropdown-item v-if="isSystemAdminUser" @click="$router.push('/knowledge/graph/editor/jointjs')">
                    <el-icon><Share /></el-icon>
                    <span>关系图编辑器 (jointjs)</span>
                  </el-dropdown-item>
                  
                  <el-dropdown-item @click="handleCommand('logout')">
                    <el-icon><SwitchButton /></el-icon>
                    <span>退出登录</span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </div>
        </template>
        <template v-else>
          <div class="user-menu-item">
            <button type="button" class="login-btn-prominent" @click="goToLogin($router, $route.fullPath)">
              <el-icon><User /></el-icon>
              <span>登录</span>
            </button>
          </div>
        </template>
      </div>
    </el-header>

    <el-header v-else class="auth-mobile-header">
      <div class="header-container auth-header-minimal">
        <router-link to="/" class="auth-logo-link">
          <img src="@/assets/coolpeople.png" alt="logo" class="logo">
        </router-link>
        <span class="auth-page-title">{{ authPageTitle }}</span>
      </div>
    </el-header>

    <el-main :class="mainClasses">
      <ReferralBindBanner v-if="!isSimpleAuthLayout && !isAdminRoute && !isCourseDisplayRoute" />
      <RouterView />
      <FooterView v-if="showSiteFooter" />
      <CopyRight v-if="showSiteFooter" />
    </el-main>
  </el-container>
</template>

<script>
import {    InfoFilled, User, SwitchButton, CaretBottom, Setting, Document,   View, Search, Share, Download, Ticket, QuestionFilled, ChatDotRound } from '@element-plus/icons-vue'
import CopyRight from './components/CopyRight.vue'
import FooterView from './components/FooterView.vue'
import MobileNavBar from './components/layout/MobileNavBar.vue'
import ReferralBindBanner from './components/ReferralBindBanner.vue'
import authManager from '@/utils/auth'
import { isSystemAdmin } from '@/utils/sysRole'
import { goToLogin, markWechatSkipAutoLogin } from '@/utils/loginFlow'
import { isMobileDevice, isCompactViewport, isWechatBrowser } from '@/utils/browser'
import { clearAllGuestExamSids } from '@/utils/guestExam'
import { clearGuestClaimContext } from '@/utils/examClaim'
import { registerAppAuth } from '@/utils/appAuth'
import { resolveAccessExpireMs } from '@/utils/auth'

export default {
  name: 'App',
  components: {
    CopyRight,
    FooterView,
    MobileNavBar,
    ReferralBindBanner,
    InfoFilled,
    User,
    SwitchButton,
    CaretBottom,
    Setting,
    Document,
    Search,
    View,
    Share,
    Download,
    Ticket,
    QuestionFilled,
    ChatDotRound
  },
  data() {
    return {
      isLoggedIn: false,
      userInfo: {
        username: '',
        nickname: '',
        avatar: '',
        sysRole: ''
        
      },
      expireTime: 0,
      compactNav: isCompactViewport()
    }
  },
  provide() {
    return {
      appUserInfo: this.userInfo,
      appIsLoggedIn: this.isLoggedIn,
      compactViewport: () => this.useCompactNav
    }
  },
  computed: {
    isAdminRoute() {
      return this.$route.path.startsWith('/admin')
    },
    isCourseDisplayRoute() {
      return this.$route.path.startsWith('/knowledge/courses/display')
    },
    showSiteFooter() {
      if (this.$route.path === '/wechatcallback') {
        return false
      }
      if (this.isCourseDisplayRoute) {
        return false
      }
      return !this.isSimpleAuthLayout && !this.isAdminRoute
    },
    mainClasses() {
      return {
        'auth-mobile-main': this.isSimpleAuthLayout,
        'app-main--compact': this.useCompactNav && !this.isSimpleAuthLayout && !this.isAdminRoute,
        'app-main--course-display': this.isCourseDisplayRoute
      }
    },
    isSystemAdminUser() {
      return isSystemAdmin(this.userInfo.sysRole)
    },
    isSimpleAuthLayout() {
      if (!isMobileDevice()) return false
      const path = this.$route.path
      return path === '/login' || path === '/register' || path === '/security/captcha'
    },
    authPageTitle() {
      const titles = {
        '/login': '登录',
        '/register': '注册',
        '/security/captcha': '安全验证'
      }
      return titles[this.$route.path] || ''
    },
    useCompactNav() {
      return this.compactNav
    }
  },
  mounted() {
    registerAppAuth(this)
    this.refreshAuthFromStorage()
    this.onViewportChange = () => {
      this.compactNav = isCompactViewport()
    }
    window.addEventListener('resize', this.onViewportChange)
  },
  beforeUnmount() {
    if (this.onViewportChange) {
      window.removeEventListener('resize', this.onViewportChange)
    }
  },
  created() {
    this.refreshAuthFromStorage()
  },
  methods: {
    refreshAuthFromStorage() {
      const token = localStorage.getItem('jwt_token')
      const userInfoRaw = localStorage.getItem('user_info')
      const expireTime = parseInt(localStorage.getItem('expire_time'), 10)

      if (token && userInfoRaw && expireTime && expireTime > Date.now()) {
        try {
          this.userInfo = JSON.parse(userInfoRaw)
        } catch {
          this.userInfo = { username: '', nickname: '', avatar: '', sysRole: '' }
        }
        this.isLoggedIn = true
        this.expireTime = expireTime
        authManager.startKeepLoginTimer()
        return
      }

      localStorage.removeItem('jwt_token')
      localStorage.removeItem('user_info')
      localStorage.removeItem('expire_time')
      this.isLoggedIn = false
      this.userInfo = { username: '', nickname: '', avatar: '', sysRole: '' }
      this.expireTime = 0
    },
    login(logindata) {
      console.log("login-start", logindata)

      this.isLoggedIn = true
      this.userInfo = { 
        uuid: logindata.uuid,
        avatar: logindata.avatar,
        username: logindata.username,
        usernameAuto: !!logindata.usernameAuto,
        nickname: logindata.nickname,
        sysRole: logindata.sysRole,
        orgs: logindata.orgs
        
      }

          // 保存 token 和用户信息
      // this.token = logindata.accessToken
    
      
      // console.log("localStorage.setItem-userInfo",JSON.stringify(this.userInfo))
      // console.log("localStorage.setItem-userInfo",JSON.stringify(logindata))
  

      localStorage.setItem('uuid', logindata.uuid)
      localStorage.setItem('user_info', JSON.stringify(this.userInfo))
      localStorage.setItem('user_role', logindata.sysRole)
      localStorage.setItem('jwt_token', logindata.accessToken)
      this.expireTime = resolveAccessExpireMs(logindata.accessExpire)
      localStorage.setItem('expire_time', this.expireTime.toString())


      const token = localStorage.getItem('jwt_token')
      console.log("login-end-token=", token)
      console.log("login-end")
      
     
      // console.log("setItem-start")
      // localStorage.setItem('user_info', JSON.stringify(userData))
      // localStorage.setItem('user_role', userData.sysRole) 
      // localStorage.setItem('jwt_token', userData.accessToken )
      // this.expireTime =  accessExpire * 1000
      // localStorage.setItem('expire_time', this.expireTime.toString())
      // console.log("setItem-OK")
    
    },
    logout() {
      this.isLoggedIn = false
      this.userInfo = { username: '', nickname: '', avatar: '' }
      
      console.log("removeItem--jwt_token2-")
      localStorage.removeItem('jwt_token')
      localStorage.removeItem('user_info')
      localStorage.removeItem('expire_time')
      clearAllGuestExamSids()
      clearGuestClaimContext()
      authManager.logout()
      markWechatSkipAutoLogin()
      if (isWechatBrowser()) {
        const path = this.$route.path
        if (path === '/login' || path === '/register' || path === '/officialcallback' || path === '/wechatcallback') {
          this.$router.replace('/')
        } else if (this.$route.meta?.requiresAuth) {
          this.$router.replace('/')
        }
      } else {
        goToLogin(this.$router, this.$route.fullPath)
      }
    },
    goToLogin,
    handleCommand(command) {
      if (command === 'logout') {
        this.logout()
      } else if (command === 'account') {
        this.$router.push('/user/password')
      }
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100vh;
}
.logo {
  height: 32px;
}

@media screen and (max-width: 600px) {
  .nav-menu .el-menu-item:first-child {
    display: none;
  }
}

.el-container {
  height: 100%;
}

.el-header {
  padding: 0 !important; 
  height: auto !important;
}

.header-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: solid 1px var(--el-menu-border-color);
  background-color: #ffffff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.nav-menu {
  border: none;
  min-width: 300px;
  flex-grow: 1;
  background-color: transparent;
}

.user-menu-item {
  display: flex;
  align-items: center;
  height: 60px;
  margin-right: 20px;
}

.user-menu-item .el-link {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: 4px;
  transition: all 0.3s;
}

.user-menu-item .el-link:hover {
  background-color: var(--el-color-primary-light-9);
}

.user-menu-item .el-link .el-icon {
  font-size: 18px;
}

.user-menu-item .el-link span {
  font-weight: 500;
}

.login-btn-prominent {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  background: linear-gradient(135deg, #42b983 0%, #35946a 100%);
  border: none;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(66, 185, 131, 0.35);
  cursor: pointer;
  transition: opacity 0.2s;
}

.login-btn-prominent:hover {
  opacity: 0.92;
}

.login-btn-prominent .el-icon {
  font-size: 18px;
}

.user-dropdown-trigger {
  display: flex;
  align-items: center;
  padding: 0 20px;
  cursor: pointer;
  height: 60px;
  white-space: nowrap;
}

.username-text {
  margin-left: 8px;
  margin-right: 4px;
  font-weight: 500;
}

@media screen and (max-width: 768px) {
  .username-text {
    display: none;
  }
}

.el-dropdown-menu__item .el-icon {
  margin-right: 8px;
}

.el-dropdown-menu__item span {
  margin-left: 4px;
}

.el-main {
  padding: 0 !important;
  min-height: calc(100vh - 180px);
}

.app-main--course-display {
  min-height: 0;
  height: calc(100vh - 60px);
  overflow: hidden;
}

.auth-mobile-header {
  padding: 0 !important;
  height: auto !important;
}

.auth-header-minimal {
  justify-content: center;
  padding: 12px 16px;
  box-shadow: none;
  border-bottom: 1px solid #eee;
}

.auth-logo-link {
  display: flex;
  align-items: center;
}

.auth-page-title {
  margin-left: 10px;
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.auth-mobile-main {
  min-height: calc(100vh - 56px);
  background: #f7f8fa;
}

.auth-mobile-layout .el-container {
  background: #f7f8fa;
}
</style>
